module.exports = __webpack_public_path__ + "media/images/heading-mv-a94bab1a317c6f962c0a4ab8e669e0fc.svg";